export const placementList = [
  { key: 'TopLeft', text: 'Top left' },
  { key: 'Center', text: 'Center' },
  { key: 'BottomRight', text: 'Bottom right' },
];
